// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--24cdb","center":"contact-module--center--3DPvA","formControl":"contact-module--formControl--2ooxW","submit":"contact-module--submit--c0PD7"};